import type { Instance } from '@empathybroker/tsclient-play/dist/models/instance/instance'

import type { ConfigState, GetterClass } from '../../../models'

import { KpiEnum } from '../../../enums'

import { CONFIG_CONSTS } from '../../../store/config/config.consts'

export class SearchKpisGetter implements GetterClass {
  static execute(this: void, state: ConfigState, getters: any): KpiEnum[] {
    const instanceConfig: Instance = getters[CONFIG_CONSTS.getters.currentInstance]
    if (!!instanceConfig && !!instanceConfig.kpis) {
      return instanceConfig.kpis.reduce((supportedKpis: KpiEnum[], instanceConfigKpi: string) => {
        // TODO: avoid Enum translate
        const kpi = instanceConfigKpi === 'noResults' ? KpiEnum.NO_RESULTS : instanceConfigKpi
        if ((Object.values(KpiEnum) as string[]).includes(kpi)) {
          supportedKpis.push(kpi as KpiEnum)
        }
        return supportedKpis
      }, [])
    }
    return []
  }
}
